import * as React from "react";
import { Container } from "../container/container.mjs";
import { Heading } from "../typography/heading/heading.mjs";
import "debounce";
import "tabbable";
import { useCurrentBreakPoint } from "../helpers/helper/hooks/use-current-breakpoint.mjs";
import { Separator } from "../separator/separator.mjs";
const SectionHeading = (props) => {
  const { headingLevel, title, isFirstTable, count } = props;
  const currentBreak = useCurrentBreakPoint();
  const renderHeading = () => {
    return /* @__PURE__ */ React.createElement(Heading, { level: headingLevel, className: "h4" }, title, count && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement("span", { className: "text-light" }, "(", count, ")")));
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !isFirstTable && /* @__PURE__ */ React.createElement(Separator, { spacing: "small", color: "invisible" }), currentBreak === "md" ? /* @__PURE__ */ React.createElement(Container, null, renderHeading()) : renderHeading(), /* @__PURE__ */ React.createElement(Separator, { spacing: "xsmall", color: "invisible" }));
};
export {
  SectionHeading
};
